"use strict";

exports.__esModule = true;
exports.useTriggerTransition = exports.useTransitionState = void 0;

var _useTransitionState = require("./useTransitionState");

exports.useTransitionState = _useTransitionState.useTransitionState;

var _useTriggerTransition = require("./useTriggerTransition");

exports.useTriggerTransition = _useTriggerTransition.useTriggerTransition;